<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">{{ $t('puzzleTerm.list.subtitle') }}</span>
        <h3 class="page-title d-inline">{{ $t('puzzleTerm.list.title') }}</h3>
        <button type="button" class="btn btn-success float-right" @click="newPuzzle()">{{ $t('puzzleTerm.list.add') }}</button>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-3">
              <h6 class="m-0">{{ $t('puzzleTerm.table.title') }}</h6>
            </div>
            <div class="col-9 px-0">
              <form class="w-100 d-flex">
                <div class="col-3">
                  <select class="form-control" v-model="pagination.letter">
                    <option :value="null">{{ $t('puzzleTerm.table.letterFilter') }}</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                  </select>
                </div>
                <div class="col-2 px-0">
                  <datepicker
                    type="date"
                    format="DD/MM/YYYY"
                    :model.sync="pagination.date"
                  />
                </div>
                <div class="ml-3">
                  <button @click="pagination.date = null" class="btn btn-primary">{{ $t('shared.actions.clear') }}</button>
                </div>
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    :placeholder="$t('puzzleTerm.table.searchPlaceholder')"
                    :aria-label="$t('shared.actions.search')"
                    v-model="pagination.search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <puzzle-table :puzzles="puzzle.list" />
            </div>
            <pagination :event-name="UPDATE_PUZZLE_PAGINATION" :total-items="puzzle.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Datepicker from '_shared/Datepicker.vue';
import Pagination from '_shared/Pagination.vue';
import PuzzleTable from '../components/PuzzleListTable.vue';
import { _NEW_MODEL_, _UPDATE_PUZZLE_PAGINATION_ } from '../components/PuzzleTermModel';

export default {
  name: 'puzzle-term-list',
  components: {
    Datepicker,
    Pagination,
    PuzzleTable,
  },
  data() {
    return {
      UPDATE_PUZZLE_PAGINATION: _UPDATE_PUZZLE_PAGINATION_,
      pagination: {
        search: '',
        letter: null,
        date: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    puzzle() {
      const { puzzleList } = this.$store.state.puzzleTerm;
      if (puzzleList && puzzleList.list.length) {
        return puzzleList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getPuzzleTermList',
    ]),
    newPuzzle() {
      Events.$emit(_NEW_MODEL_);
      this.setToggle({ type: 'puzzle_form_modal', bool: true });
    },
    getList() {
      this.getPuzzleTermList(this.pagination);
    },
  },
  destroyed() {
    Events.$off(_UPDATE_PUZZLE_PAGINATION_);
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on(_UPDATE_PUZZLE_PAGINATION_, pagination => {
      if (pagination.page !== this.$route.params.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
    this.getList();
  },
};
</script>
